import React, {  useEffect, useState} from 'react';
import SpecialDraggedItemUI from '../components/ui/SpecialDraggedItemUI';
import { useWindowSize } from '../cvp-webgames-core/hooks/useWindowSize';
import { constants } from '../misc/constants';
import { globals } from '../misc/globals';
import { Windows } from '../misc/tools';
import GamePage from './Game';
import MainMenuPage from './MainMenu';

const MainPage = () => {
	const [windowToUse, setWindowToUse] = useState(Windows.MainMenu);
	var isInitializing: boolean = false;

	const windowSize: any = useWindowSize();

	const scale = Math.min(windowSize.width / 1920, windowSize.height / 1080);
	globals.worldScale = scale;
	useEffect(() => {
		if(!isInitializing) {
			var url = new URL(window.location.href);
			var search_params = url.searchParams;
			var w: any = search_params.get('w');
			if(w && parseInt(w) !== Windows.Nothing) {
				setWindowToUse(parseInt(w));
			} else {
				setWindowToUse(Windows.MainMenu);
			}
			setTimeout(() => {
				(window as any)['uiContainerChanged']();
			}, 0);
			isInitializing = true;
		}
	})

	const updateWindow = (windowToUse: Windows): void => {
		//setWindow(window);
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		
		search_params.set('w', windowToUse.toString());

		url.search = search_params.toString();

		window.location.href = url.toString();
	}
	
	return (
		<div style={{
			position: 'relative',
			top: '0',
			left: '0',
		}}>
			<div style={{
				position: "fixed",
				width: "1920px",
				height: "1080px",
				transform: `scale(${scale}) translate(-50%, -50%)`,
				transformOrigin: "0px 0px",
				top: "50%",
				left: "50%",
			}} id="game-root-page-obj">
				{windowToUse === Windows.MainMenu ? <MainMenuPage updateWindow={updateWindow}></MainMenuPage> : (null)}
				{windowToUse === Windows.NathanielClarke ? <GamePage updateWindow={updateWindow} scenarioId={Windows.NathanielClarke.toString()}></GamePage>: (null)}
				{windowToUse === Windows.JavierMcBride ? <GamePage updateWindow={updateWindow} scenarioId={Windows.JavierMcBride.toString()}></GamePage>: (null)}
				{windowToUse === Windows.DamonJones ? <GamePage updateWindow={updateWindow} scenarioId={Windows.DamonJones.toString()}></GamePage>: (null)}
				{windowToUse === Windows.AndreGarza ? <GamePage updateWindow={updateWindow} scenarioId={Windows.AndreGarza.toString()}></GamePage>: (null)}
				{windowToUse === Windows.GuadalupeHerrera ? <GamePage updateWindow={updateWindow} scenarioId={Windows.GuadalupeHerrera.toString()}></GamePage>: (null)}
				{windowToUse === Windows.DarnellKennedy ? <GamePage updateWindow={updateWindow} scenarioId={Windows.DarnellKennedy.toString()}></GamePage>: (null)}
				{windowToUse === Windows.FaithAlvarado ? <GamePage updateWindow={updateWindow} scenarioId={Windows.FaithAlvarado.toString()}></GamePage>: (null)}
				{windowToUse === Windows.EmanuelMcKenzie ? <GamePage updateWindow={updateWindow} scenarioId={Windows.EmanuelMcKenzie.toString()}></GamePage>: (null)}
				{windowToUse === Windows.RuthMcKenzie ? <GamePage updateWindow={updateWindow} scenarioId={Windows.RuthMcKenzie.toString()}></GamePage>: (null)}
				{windowToUse === Windows.LeroyRobinson ? <GamePage updateWindow={updateWindow} scenarioId={Windows.LeroyRobinson.toString()}></GamePage>: (null)}
				{windowToUse === Windows.WilliamHoward ? <GamePage updateWindow={updateWindow} scenarioId={Windows.WilliamHoward.toString()}></GamePage>: (null)}
				{windowToUse === Windows.AngelaScott ? <GamePage updateWindow={updateWindow} scenarioId={Windows.AngelaScott.toString()}></GamePage>: (null)}
			</div>
			<SpecialDraggedItemUI scale={scale}></SpecialDraggedItemUI>
		</div>
		
	);
};

export default MainPage;
